import { render, staticRenderFns } from "./PromoteView.vue?vue&type=template&id=04468294&scoped=true&"
import script from "./PromoteView.vue?vue&type=script&lang=ts&"
export * from "./PromoteView.vue?vue&type=script&lang=ts&"
import style0 from "./PromoteView.vue?vue&type=style&index=0&id=04468294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04468294",
  null
  
)

export default component.exports